const knowledgebaseHu = {
    "failed_to_load": "Nem sikerült betölteni a cikkeket",
    "welcome_to_knowledgebase": "Üdvözlünk a tudásbázisban!",
    "choose_from_categories": "Kérjük válassz az alábbi kategóriák közül, vagy a fenti keresőmezőt vedd igénybe a kérdéseid megválaszolására!",
    "search_placeholder": "Keresés...",
    "not_found_what_you_looking_for": "Nem találtál meg valamit? Írj az alábbi email címre: ",
    "article_button": "Tovább",
    "knowledgebase": "Tudásbázis",
    "article_not_found": "A cikk nem található",
    "back_to_list": "Vissza a lista oldalhoz",
    "no_articles_found": "Nincsenek cikkek",
    "search_for_any_keyword": "Keress bármilyen kulcsszóra folyamatosan bővülő tudásbázisunkban!",
}

export default knowledgebaseHu;